import type {z} from "zod";

import {UpdateServiceBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {serviceFieldLabelIds} from "../../../messages/services.messages";

const fields = UpdateServiceBody.shape;
export const updateServiceFormSchema = zod.object({
  code: requiredStringSchema(fields.code, serviceFieldLabelIds.code),
  name: requiredStringSchema(fields.name, serviceFieldLabelIds.name),
  internalDescription: requiredStringSchema(
    fields.internalDescription,
    serviceFieldLabelIds.internalDescription,
  ),
  billingUnit: fields.billingUnit,
});
export type UpdateServiceFormPayload = z.output<typeof updateServiceFormSchema>;

export const draftUpdateServiceFormSchema = updateServiceFormSchema.partial();
export type DraftUpdateServiceFormPayload = z.output<typeof draftUpdateServiceFormSchema>;
